<div id="matDialogContent">
  <div id="matDialogContentData" [innerHTML]="message"></div>
</div>
